(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spencer-catalog-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('sa-interest');
    if (!dialog) return;
    const title = dialog.querySelector('[data-sa-piece]');
    const tags = dialog.querySelector('[data-sa-tags]');
    const open = (link) => {
      const interest = { title: link?.dataset.saTitle || '', tag: link?.dataset.saTag || '' };
      title.textContent = interest.title;
      tags.value = ['newsletter', 'spencer-availability', interest.tag].filter(Boolean).join(',');
      try { sessionStorage.setItem('sa-availability-interest', JSON.stringify(interest)); } catch {}
      if (!dialog.open) dialog.showModal();
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-sa-notify]');
      if (link) {
        event.preventDefault();
        event.stopImmediatePropagation();
        open(link);
      }
    }, true);
    dialog.querySelector('[data-sa-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const path = new URL(form.action, location.origin).pathname;
      if (/\/(cart(?:\/add)?|checkout)\/?$/.test(path)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        open();
      }
    }, true);
    if (dialog.querySelector('[data-sa-result]') || location.hash === '#sa-interest' || location.hash === '#SaAvailabilityForm') {
      try {
        const interest = JSON.parse(sessionStorage.getItem('sa-availability-interest') || '{}');
        title.textContent = interest.title || '';
        tags.value = ['newsletter', 'spencer-availability', interest.tag].filter(Boolean).join(',');
      } catch {}
      dialog.showModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
